import React, { useEffect } from "react";
import { MapPin, Phone, Mail, Clock, Facebook, MessageCircle } from "lucide-react";
import RFQForm from "@/components/contact/RFQForm";
import { pushEvent } from "@/lib/gtm";

export default function Contact() {
  useEffect(() => {
    pushEvent("page_view_spa", { page_type: "contact", page_path: "/contact", page_title: "Request a Quotation" });
  }, []);

  return (
    <>
      <section className="bg-[#0A0A0A] pt-40 pb-28 clip-diagonal-bottom relative overflow-hidden">
        <div className="absolute top-0 right-0 h-full w-40 bg-[#E4001C]/70 hidden md:block" style={{ clipPath: "polygon(60% 0, 100% 0, 40% 100%, 0 100%)" }} />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 relative">
          <p className="font-tech font-semibold uppercase tracking-[0.25em] text-[#E4001C] text-sm mb-4">Contact</p>
          <h1 className="font-heading font-extrabold uppercase text-white text-5xl md:text-7xl tracking-wide max-w-3xl">
            Request a Quotation
          </h1>
        </div>
      </section>

      <section className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 grid grid-cols-1 lg:grid-cols-3 gap-12">
          <div className="lg:col-span-2">
            <RFQForm />
          </div>
          <div className="space-y-8">
            <div>
              <h2 className="font-heading font-extrabold uppercase text-2xl tracking-wide mb-6 text-[#171717]">Company Details</h2>
              <ul className="space-y-5 text-sm text-[#171717]/70">
                <li className="flex items-start gap-3"><MapPin className="w-5 h-5 text-[#E4001C] mt-0.5 shrink-0" /> 32nd Street corner 11th Avenue Brgy. Fort Bonifacio, Bonifacio, Taguig, 1634 Metro Manila, Taguig, Philippines<br /></li>
                <li className="flex items-center gap-3"><Phone className="w-5 h-5 text-[#E4001C] shrink-0" /> <a href="tel:+639614407996" onClick={() => pushEvent("contact_click", { method: "phone", location: "contact_page" })} className="hover:text-[#E4001C] transition-colors">+63 961 440 7996</a></li>
                <li className="flex items-center gap-3"><Mail className="w-5 h-5 text-[#E4001C] shrink-0" /> <a href="mailto:seisfraph@gmail.com" onClick={() => pushEvent("contact_click", { method: "email", location: "contact_page" })} className="hover:text-[#E4001C] transition-colors">seisfraph@gmail.com</a></li>
                <li className="flex items-center gap-3"><Clock className="w-5 h-5 text-[#E4001C] shrink-0" /> Mon–Sat, 8:00 AM – 5:00 PM</li>
              </ul>
            </div>
            <div>
              <h3 className="font-tech font-semibold uppercase tracking-widest text-sm text-[#171717] mb-4">Message Us</h3>
              <div className="flex gap-3">
                <a href="https://www.facebook.com/profile.php?id=61587997265633" target="_blank" rel="noopener noreferrer" aria-label="Facebook"
                  onClick={() => pushEvent("contact_click", { method: "facebook", location: "contact_page" })}
                  className="w-11 h-11 flex items-center justify-center bg-[#0A0A0A] hover:bg-[#E4001C] text-white transition-colors">
                  <Facebook className="w-5 h-5" />
                </a>
                <a href="https://m.me" target="_blank" rel="noopener noreferrer" aria-label="Messenger"
                  onClick={() => pushEvent("contact_click", { method: "messenger", location: "contact_page" })}
                  className="w-11 h-11 flex items-center justify-center bg-[#0A0A0A] hover:bg-[#E4001C] text-white transition-colors">
                  <MessageCircle className="w-5 h-5" />
                </a>
              </div>
            </div>
            <div className="bg-[#F5F5F5] border border-gray-200 aspect-square overflow-hidden relative">
              <iframe
                title="Office Location Map"
                src="https://maps.google.com/maps?q=32nd%20Street%20corner%2011th%20Avenue%20Brgy.%20Fort%20Bonifacio%2C%20Taguig%2C%20Philippines&t=&z=16&ie=UTF8&iwloc=&output=embed"
                className="w-full h-full border-0 grayscale hover:grayscale-0 transition-all duration-300"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}